


// import React from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     IconButton,
//     Typography,
//     Grid,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Paper,
//     Box,
//     Divider,
//     Button,
//     Stack,
// } from '@mui/material';
// import { MdCancel } from "react-icons/md";
// import "./TableDataViewModal.css";
// import documentImage from "../../../Assets/Emirates_ID_Card_For_UAE_Citizens_(New).png"


// const ReferrerTableViewModal = ({ open, onClose, modalViewHeadingName }) => {
//     const purchaser = {
//         firstName: 'Mani',
//         lastName: 'Krish',
//         email: 'manikrish@gmail.com',
//         mobileNumber: '9823281781',
//         userType: 'Individual',
//         documentType: 'Emirates ID',
//         addressLine1: 'CL-720',
//         addressLine2: 'Afza, Ajman',
//         city: 'Al Ain',
//         state: 'Abu Dhabi',
//         country: 'United Arab Emirates',
//         zipcode: '20000',
//         schemes: [
//             {
//                 name: 'Mani Krish',
//                 ReferralType: 'Inividual',
//                 userType: 'Financial Consultant',
//                 email: 'manikrish@gmail.com',
//                 mobileNumber: "3590040985984"

//             },
//             {
//                 name: 'Mani Krish',
//                 ReferralType: 'Inividual',
//                 userType: 'Financial Consultant',
//                 email: 'manikrish@gmail.com',
//                 mobileNumber: "3590040985984"

//             }
//         ],
//     };
//     const TableHeadModalData = ["Referral's Name", "Referral Type", "User Type", "Email", "Mobile Number",]

//     const Documents = [documentImage, documentImage, documentImage]

//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 "& .MuiPaper-root": {
//                     borderRadius: "14px",
//                 },
//             }}
//         >
//             <Box sx={{ position: 'relative' }}>
//                 {/* Dialog Header */}
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={onClose}
//                         sx={{
//                             position: 'absolute',
//                             top: 8,
//                             right: 8,
//                             color: 'text.secondary',
//                         }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">
//                         <Typography className="custom-title-text" color="white">
//                             {modalViewHeadingName}
//                         </Typography>
//                     </DialogTitle>
//                 </Box>
//             </Box>

//             <DialogContent>
//                 <Box p={{ xs: 2, md: 1 }}>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>
//                         {/* Aligning using flex and justifyContent */}


//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     First Name
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.firstName}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Last Name
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.lastName}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     User Type
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.userType}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Email
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.email}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Mobile Number
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.mobileNumber}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Document Type
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.documentType}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Address Line 1
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.addressLine1}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Address Line 2
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.addressLine2}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     City
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.city}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     State
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.state}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     country
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.country}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Zipcode
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.zipcode}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>


//                     <Divider sx={{ mt: 3 }} />

//                     {/* Schemes Table */}
//                     <Box mt={4}>
//                         <Typography variant="body2" gutterBottom>
//                             Referred By
//                         </Typography>
//                         <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
//                             <Table sx={{ borderCollapse: 'collapse' }}>
//                                 <TableHead>
//                                     <TableRow sx={{ p: "16px 0" }}>
//                                         {TableHeadModalData.map((data, index) => (

//                                             <TableCell sx={{
//                                                 color: "#7A7A7A", border: "none", p: "10px 10px 0 0px", whiteSpace: 'nowrap',
//                                                 textOverflow: 'ellipsis',
//                                             }}>
//                                                 <Typography variant='body1'> {data}</Typography></TableCell>
//                                         ))}
//                                     </TableRow>
//                                 </TableHead>

//                                 <TableBody>
//                                     {purchaser.schemes.map((scheme, index) => (
//                                         <TableRow key={index}>
//                                             {Object.keys(scheme).map((key) => (
//                                                 <TableCell key={key} sx={{
//                                                     border: "none",  p: "10px 10px 0 0px", whiteSpace: 'nowrap',
//                                                     textOverflow: 'ellipsis',
//                                                 }} >
//                                                     <Typography variant='subtitle2'>
//                                                         {scheme[key]}
//                                                     </Typography>
//                                                 </TableCell>
//                                             ))}
//                                         </TableRow>
//                                     ))}
//                                 </TableBody>

//                             </Table>
//                         </TableContainer>
//                     </Box>



//                 </Box>
//             </DialogContent>
//         </Dialog >
//     );
// };

// export default ReferrerTableViewModal;






import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box,
    Divider,
    Button,
    Stack,
} from '@mui/material';
import { MdCancel } from "react-icons/md";
import "./TableDataViewModal.css";
import documentImage from "../../../Assets/Emirates_ID_Card_For_UAE_Citizens_(New).png"
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../ReduxStore/actions/index";

const ReferrerTableViewModal = ({ open, onClose, modalViewHeadingName }) => {

    const dispatch = useDispatch();

    const purchaser = {
        firstName: 'Mani',
        lastName: 'Krish',
        email: 'manikrish@gmail.com',
        mobileNumber: '9823281781',
        userType: 'Individual',
        documentType: 'Emirates ID',
        addressLine1: 'CL-720',
        addressLine2: 'Afza, Ajman',
        city: 'Al Ain',
        state: 'Abu Dhabi',
        country: 'United Arab Emirates',
        zipcode: '20000',
        schemes: [
            {
                name: 'Mani Krish',
                ReferralType: 'Inividual',
                userType: 'Financial Consultant',
                email: 'manikrish@gmail.com',
                mobileNumber: "3590040985984"

            },
            {
                name: 'Mani Krish',
                ReferralType: 'Inividual',
                userType: 'Financial Consultant',
                email: 'manikrish@gmail.com',
                mobileNumber: "3590040985984"

            }
        ],
    };
    const TableHeadModalData = ["Referral's Name", "Referral Type", "User Type", "Email", "Mobile Number",]



    const { getReferrerCustomerRewardsByCustomerId } = useSelector((state) => state?.getReferrerCustomerRewardsByCustomerId);
    const customerId = useSelector((state) => state.customer.customerId);

    console.log(customerId, "ReferrerTableViewModalReferrerTableViewModal");


    console.log(getReferrerCustomerRewardsByCustomerId?.data, "getAllCustomersStatusgetAllCustomersStatus");

    useEffect(() => {
        if(!open) return;
        const fetchData = async () => {
            if (customerId) {
                const data1 = { data: {}, method: "get", apiName: `getReferrerCustomerRewardsByCustomerId/${customerId}` };
                await dispatch(actions.GETREFERRERCUSTOMERREWARDSBYCUSTOMERID(data1));
            }
        };
        fetchData();
    }, [dispatch, customerId]);



    const [rowTableData, setRowTableData] = useState({
        firstName: '--',
        lastName: '--',
        email: '--',
        mobileNumber: '--',
        // schemes: [
        //     {
        //         name: 'Mani Krish',
        //         email: 'manikrish@gmail.com',
        //         useType: 'Financial Consultant',
        //         JoindOnDate: '15 Jan 2025',

        //     },
        // ],
    });

    useEffect(() => {
        const tempArr = [];
        // getReferrerCustomerRewardsByCustomerId?.data?.map((data, index) => {

        //     return tempArr.push({
        //         Name: `${data?.first_name} ${data?.last_name}`,
        //         customer_id: data?.customer_id,
        //         email: data?.email,
        //         phone: data?.phone,
        //         role: data?.role === "customer" ? "Individual" : data?.role,
        //         approval_status: data?.approval_status.charAt(0).toUpperCase() + data?.approval_status.slice(1),
        //     });
        // });

        if (customerId && getReferrerCustomerRewardsByCustomerId?.data) {
            setRowTableData({
                firstName: getReferrerCustomerRewardsByCustomerId?.data?.Referrercustomers?.referrer_first_name,
                lastName: getReferrerCustomerRewardsByCustomerId?.data?.Referrercustomers?.referrer_last_name,
                customer_id: getReferrerCustomerRewardsByCustomerId?.data?.Referrercustomers?.referrer_id,
                email: getReferrerCustomerRewardsByCustomerId?.data?.Referrercustomers?.referrer_email,
                mobileNumber: getReferrerCustomerRewardsByCustomerId?.data?.Referrercustomers?.referrer_phone,
                userType: getReferrerCustomerRewardsByCustomerId?.data?.Referrercustomers?.referrer_role
                // schemes: [
                //     {
                //         name: 'Mani Krish',
                //         email: 'manikrish@gmail.com',
                //         useType: 'Financial Consultant',
                //         JoindOnDate: '15 Jan 2025',

                //     },
                // ],

            });
        }
    }, [dispatch, getReferrerCustomerRewardsByCustomerId]);


    console.log(rowTableData, "rowTableDatarowTableDatarowTableData");



    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            className="custom-dialog"
            sx={{
                "& .MuiPaper-root": {
                    borderRadius: "14px",
                },
            }}
        >
            <Box sx={{ position: 'relative' }}>
                {/* Dialog Header */}
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            color: 'text.secondary',
                        }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">
                        <Typography className="custom-title-text" color="white">
                            {modalViewHeadingName}
                        </Typography>
                    </DialogTitle>
                </Box>
            </Box>

            <DialogContent>
                <Box p={{ xs: 2, md: 1 }}>
                    <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>
                        {/* Aligning using flex and justifyContent */}


                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    First Name
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.firstName}</Typography>
                            </Box>
                        </Grid>
                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Last Name
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.lastName}</Typography>
                            </Box>
                        </Grid>
                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    User Type
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.userType}</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

                        <Grid item >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Email
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.email}</Typography>
                            </Box>
                        </Grid>
                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    Mobile Number
                                </Typography>
                                <Typography variant="subtitle2">{rowTableData.mobileNumber}</Typography>
                            </Box>
                        </Grid>
                        <Grid item  >
                            <Box className="content-layout">
                                <Typography variant="body1" className="tabledataview-content-textheading">
                                    {/* Mobile Number */}
                                </Typography>
                                <Typography variant="subtitle2">{""}</Typography>
                            </Box>
                        </Grid>


                    </Grid>

                    <Divider sx={{ mt: 3 }} />

                    {/* Schemes Table */}
                    {/* <Box mt={4}>
                        <Typography variant="body2" gutterBottom>
                            Referred By
                        </Typography>
                        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                            <Table sx={{ borderCollapse: 'collapse' }}>
                                <TableHead>
                                    <TableRow sx={{ p: "16px 0" }}>
                                        {TableHeadModalData.map((data, index) => (

                                            <TableCell sx={{
                                                color: "#7A7A7A", border: "none", p: "10px 10px 0 0px", whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                            }}>
                                                <Typography variant='body1'> {data}</Typography></TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {purchaser.schemes.map((scheme, index) => (
                                        <TableRow key={index}>
                                            {Object.keys(scheme).map((key) => (
                                                <TableCell key={key} sx={{
                                                    border: "none", p: "10px 10px 0 0px", whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis',
                                                }} >
                                                    <Typography variant='subtitle2'>
                                                        {scheme[key]}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Box> */}


                    <Typography variant="body2" gutterBottom sx={{ mt: 3 }}>
                        {"rewards By Tier"}
                    </Typography>
                    <Box mt={4}>
                        {Object.entries(getReferrerCustomerRewardsByCustomerId?.data?.Referrercustomers?.rewardsByTier || {}).map(([tier, rewards]) => (
                            <div key={tier} style={{ marginTop: "20px" }}>
                                <Typography variant="body2" gutterBottom>
                                    {tier.charAt(0).toUpperCase() + tier.slice(1)} {/* Converts 'gold' to 'Gold' */}
                                </Typography>
                                <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                                    <Table sx={{ borderCollapse: 'collapse' }}>
                                        <TableHead>
                                            <TableRow>
                                                {["Customer Id", "Customer Name", "Customer Email", "Customer Phone", "Gold Grams", "Purchase Date", "Purchase Stake"].map((header) => (
                                                    <TableCell key={header} sx={{ color: "#7A7A7A", border: "none", p: "10px 10px 0 0px", whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                                        <Typography variant='body1'>{header}</Typography>
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rewards.length > 0 ? (
                                                rewards.map((reward) => (
                                                    <TableRow key={reward.reward_id}>
                                                        <TableCell>
                                                            <Typography variant='subtitle2'>{reward.triggered_by.customer_id}</Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant='subtitle2'>{`${reward.triggered_by.first_name} ${reward.triggered_by.last_name}`}</Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant='subtitle2'>{reward.triggered_by.email}</Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant='subtitle2'>{reward.triggered_by.phone}</Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant='subtitle2' sx={{
                                                                whiteSpace: "nowrap",
                                                                textOverflow: "ellipsis"
                                                            }}>{Math.round(reward.reward_amount_gold_grams * 100) / 100} g</Typography>
                                                        </TableCell>

                                                        <TableCell>
                                                            <Typography variant='subtitle2'>{new Date(reward.purchase.purchase_date).toLocaleDateString()}</Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant='subtitle2'>{reward.purchase.purchase_stake}</Typography>
                                                        </TableCell>

                                                    </TableRow>
                                                ))) : (
                                                <TableRow>
                                                    <TableCell colSpan={8} align="center">
                                                        <Typography variant='subtitle2'>No Customer Found</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        ))}
                    </Box>




                </Box>
            </DialogContent>
        </Dialog >
    );
};

export default ReferrerTableViewModal;
